import {
  createFileRoute,
  getRouteApi,
  Outlet,
  useMatchRoute,
} from '@tanstack/react-router';
import WeekplanLayout from '~/containers/WeekplanLayout';
import type { WeekplanView } from '~/components/WeekplanViewSwitcher';

const route = getRouteApi('/weekplan/$year/$week');

function WeekplanLayoutRoute() {
  const params = route.useParams();
  const matchRoute = useMatchRoute();
  const isOverview = Boolean(
    matchRoute({ to: '/weekplan/$year/$week/overview' })
  );
  const activeView: WeekplanView = isOverview ? 'overview' : 'weekplan';

  return (
    <WeekplanLayout
      activeView={activeView}
      year={parseInt(params.year, 10)}
      week={parseInt(params.week, 10)}
    >
      <Outlet />
    </WeekplanLayout>
  );
}

export const Route = createFileRoute('/weekplan/$year/$week')({
  component: WeekplanLayoutRoute,
});
